import { z } from 'zod';

export const LocalesSchema = z.enum(['de', 'en']);
export type TLocales = z.infer<typeof LocalesSchema>;
